import { POINT_TYPE_LIST } from "./mapPointTypes";

const TypeFilter = ({
  value,
  onChange,
  counts = {},
  theme = "dark",
  typeKeys = POINT_TYPE_LIST.map((t) => t.key),
}) => {
  const dark = theme === "dark";
  const base =
    "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold border transition";
  const inactive = dark
    ? "bg-slate-800 border-slate-700 text-slate-300 hover:bg-slate-700"
    : "bg-white border-slate-300 text-slate-600 hover:bg-slate-100";

  const options = [
    { key: "all", pluralLabel: "Tous", color: "#f59e0b", Icon: null },
    ...POINT_TYPE_LIST.filter((t) => typeKeys.includes(t.key)),
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const active = value === opt.key;
        const Icon = opt.Icon;
        const count = counts[opt.key];
        return (
          <button
            key={opt.key}
            type="button"
            onClick={() => onChange(opt.key)}
            className={`${base} ${
              active ? "text-white border-transparent shadow" : inactive
            }`}
            style={active ? { background: opt.color } : undefined}
          >
            {Icon && <Icon size={14} />}
            {opt.pluralLabel}
            {typeof count === "number" && (
              <span className={`text-xs ${active ? "text-white/80" : "opacity-70"}`}>
                ({count})
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default TypeFilter;
